import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { FaExclamationCircle } from 'react-icons/fa';
import { IconBoxType } from './types';
import CustomTheme from '../../theme';
var getBoxProps = function (type) {
    if (type === IconBoxType.WARNING) {
        return {
            color: CustomTheme.palette.warning.main,
            Icon: FaExclamationCircle,
        };
    }
    return undefined;
};
var useStyles = makeStyles(function (theme) {
    return createStyles({
        linkContainer: function (props) {
            var boxType = props.boxType;
            var color = getBoxProps(boxType).color;
            return {
                display: 'flex',
                flexDirection: 'row',
                border: "".concat(color, " solid 1px"),
                borderRadius: theme.shape.borderRadius,
            };
        },
        iconComponent: function (props) {
            var boxType = props.boxType;
            var color = getBoxProps(boxType).color;
            return {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                color: 'white',
                background: color,
                minWidth: 30,
                minHeight: 30,
                alignItems: 'center',
            };
        },
        textComponent: {
            padding: 5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
    });
});
/**
 * @deprecated
 */
var IconBox = function (props) {
    var text = props.text, boxType = props.boxType;
    var Icon = getBoxProps(boxType).Icon;
    var classes = useStyles(props);
    return (React.createElement("div", { className: classes.linkContainer },
        React.createElement("div", { "data-testid": 'iconbox-icon', className: classes.iconComponent },
            React.createElement(Icon, { size: 14 })),
        React.createElement("div", { "data-testid": 'iconbox-text', className: classes.textComponent }, text)));
};
export default IconBox;
//# sourceMappingURL=IconBox.js.map